import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.sort.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-52e209af"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("上传文件");

const _hoisted_2 = {
  class: "image-slot"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("不选择");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("商品详情");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("图文介绍");

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_7 = {
  key: 0,
  style: {
    "margin-right": "10px"
  }
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 选择品种 ");

const _hoisted_9 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_10 = {
  key: 0,
  style: {
    "margin-right": "10px"
  }
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 选择品种 ");

const _hoisted_12 = ["src"];

const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("确认");

import { ref, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { saveAttractBanner, getCarouselConfigureList } from '@/request';
import { uploadFile } from '@/request/api';
import AddAttractProductModal from './AddAttractProductModal.vue';
export default {
  name: 'AddCarouselConfigureModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    isSee: {
      type: Boolean,
      default: false
    },
    editData: {
      type: [null, Object],
      default: null
    },
    dictList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const formRef = ref();
    const showImgModal = ref(false);
    const showImgUrl = ref('');
    const option = {
      name: 'file',
      action: uploadFile.url
    };
    const showAddProductModal = ref(false);
    const uploadRef = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const scroll = ref();
    const defaultForm = {
      sort: 1,
      status: 1,
      startTime: '',
      endTime: '',
      slideshowUrl: [],
      title: '',
      goodsId: '',
      prodList: [],
      configType: 0,
      picList: []
    };
    const form = ref(_objectSpread({}, defaultForm));
    const endTimeRules = [{
      required: true,
      message: '请选择结束时间'
    }, {
      validator: (rule, value, callback) => {
        if (value && form.value.startTime && value <= form.value.startTime) {
          callback(new Error('结束时间必须晚于开始时间'));
          return;
        }

        callback();
      },
      trigger: 'change'
    }];

    function previewImg(file) {
      showImgUrl.value = file.url;
      showImgModal.value = true;
    }

    watch(() => props.modelValue, newVal => {
      scroll.value.setScrollTop(0);

      if (newVal && !props.editData) {
        var _formRef$value;

        (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.resetFields();
        uploadRef.value.clearFiles();
        form.value = _objectSpread(_objectSpread({}, defaultForm), {}, {
          picList: []
        });
      }

      if (newVal && props.editData) {
        var _props$editData$picRe, _props$editData$prodR, _props$editData$prodR2;

        form.value = _objectSpread(_objectSpread({}, props.editData), {}, {
          configType: props.editData.configType === 1 && !props.editData.goodsId ? 0 : props.editData.configType,
          picList: ((_props$editData$picRe = props.editData.picRelationList) === null || _props$editData$picRe === void 0 ? void 0 : _props$editData$picRe.map(i => ({
            url: i.resourceUrl,
            name: Date.now()
          }))) || [],
          prodNames: ((_props$editData$prodR = props.editData.prodRelationList) === null || _props$editData$prodR === void 0 ? void 0 : _props$editData$prodR.map(i => i.prodName).join(',')) || '',
          prodList: ((_props$editData$prodR2 = props.editData.prodRelationList) === null || _props$editData$prodR2 === void 0 ? void 0 : _props$editData$prodR2.map(i => i.prodNo)) || [],
          slideshowUrl: [{
            url: props.editData.slideshowUrl,
            name: Date.now()
          }]
        });
      }
    }, {
      flush: 'post'
    });

    function addProdSuccess(goods) {
      if (form.value.configType === 1) {
        form.value.goodsId = goods.goodsId;
        form.value.prodName = goods.prodName;
      } else {
        form.value.prodList = goods.map(i => i.goodsId);
        form.value.prodNames = goods.map(i => i.prodName).join(',');
      }
    }

    function beforeUpload(file) {
      if (file.size / 1024 / 1024 > 0.4) {
        ElMessage.error('文件大小不可超过 400kb!');
        return false;
      }

      if (!/.(jp(e)?g|png)$/i.test(file.name)) {
        ElMessage.error('上传文件必须是 jpg,jpeg,png格式的文件');
        return false;
      }

      return true;
    }

    function uploadSuccess(data, key) {
      if (!key) {
        if (data.code === 1) {
          form.value.slideshowUrl = [{
            url: data.data.picUrl,
            name: Date.now()
          }];
        } else {
          form.value.slideshowUrl = [];
        }

        formRef.value.validateField('slideshowUrl');
        return;
      }

      if (data.code === 1) {
        form.value[key] = form.value[key].map(file => {
          if (file.response) {
            file.url = file.response.data.picUrl;
          }

          return file;
        });
      } else {
        form.value[key] = form.value[key].filter(file => {
          if (file.response && file.response.code === 1) {
            return true;
          }

          if (!file.response) {
            return true;
          }

          return false;
        });
      }
    }

    function confirm() {
      formRef.value.validate(result => {
        if (result) {
          var _form$value$slideshow;

          if (form.value.configType === 0) {
            form.value.goodsId = '';
            form.value.prodName = '';
          }

          saveAttractBanner(_objectSpread(_objectSpread({}, form.value), {}, {
            picList: form.value.picList.map(i => i.url),
            slideshowUrl: (_form$value$slideshow = form.value.slideshowUrl[0]) === null || _form$value$slideshow === void 0 ? void 0 : _form$value$slideshow.url,
            configType: form.value.configType === 0 ? 1 : form.value.configType,
            __warn: true,
            __repeat: true
          })).then(data => {
            if (data.success) {
              ElMessage.success('操作成功!');
              emit('success');
              visible.value = false;
            }
          });
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_PictureFilled = _resolveComponent("PictureFilled");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_row = _resolveComponent("el-row");

      const _component_Plus = _resolveComponent("Plus");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _isRef(visible) ? visible.value = $event : null),
        title: __props.editData ? '编辑' : __props.isSee ? '查看' : '新增',
        top: "30px",
        width: "80%"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_13]),
          _: 1
        }), !__props.isSee ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        })) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          style: {
            "padding": "10px"
          },
          ref_key: "scroll",
          ref: scroll
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form.value,
            align: "left",
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "title",
              label: "页面标题",
              rules: {
                required: true,
                message: '请填写页面标题'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                disabled: __props.isSee,
                modelValue: form.value.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.title = $event)
              }, null, 8, ["disabled", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "排序",
              prop: "sort"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: form.value.sort,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.sort = $event),
                precision: 0,
                disabled: __props.isSee,
                min: 1,
                max: 99,
                onBlur: _cache[2] || (_cache[2] = () => form.value.sort = form.value.sort || 1)
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "开始时间",
              prop: "startTime",
              rules: {
                required: true,
                message: '请选择开始时间'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.startTime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.startTime = $event),
                disabled: __props.isSee,
                type: "date",
                "value-format": "YYYY-MM-DD",
                placeholder: "请选择开始时间",
                onChange: _cache[4] || (_cache[4] = $event => {
                  var _formRef$value2;

                  return (_formRef$value2 = formRef.value) === null || _formRef$value2 === void 0 ? void 0 : _formRef$value2.validateField('endTime');
                })
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "结束时间",
              prop: "endTime",
              rules: endTimeRules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.endTime,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.endTime = $event),
                disabled: __props.isSee,
                type: "date",
                "value-format": "YYYY-MM-DD",
                placeholder: "请选择结束时间"
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "选择文件",
              prop: "slideshowUrl",
              rules: {
                required: true,
                message: '请上传文件'
              }
            }, {
              default: _withCtx(() => [!__props.isSee ? (_openBlock(), _createBlock(_component_el_upload, {
                key: 0,
                ref_key: "uploadRef",
                ref: uploadRef,
                action: option.action,
                name: option.name,
                multiple: false,
                "show-file-list": false,
                "before-upload": beforeUpload,
                "on-success": e => uploadSuccess(e)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, null, {
                  default: _withCtx(() => [_hoisted_1]),
                  _: 1
                })]),
                _: 1
              }, 8, ["action", "name", "on-success"])) : _createCommentVNode("", true)]),
              _: 1
            }), !__props.isSee ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 0,
              style: {
                "margin-top": "10px"
              },
              title: "建议尺寸: 355*150, 大小：最大400kb 格式：jpg,jpeg,png",
              type: "warning"
            })) : _createCommentVNode("", true), _createVNode(_component_el_image, {
              class: "image",
              src: form.value.slideshowUrl[0] ? form.value.slideshowUrl[0].url : '',
              style: {
                "width": "400px",
                "height": "200px"
              },
              fit: "contain",
              "file-list": form.value.slideshowUrl,
              "onUpdate:file-list": _cache[6] || (_cache[6] = $event => form.value.slideshowUrl = $event),
              previewSrcList: [form.value.slideshowUrl[0] ? form.value.slideshowUrl[0].url : '']
            }, {
              error: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_PictureFilled)]),
                _: 1
              })])]),
              _: 1
            }, 8, ["src", "file-list", "previewSrcList"]), _createVNode(_component_el_form_item, {
              label: "选择品种",
              prop: form.value.configType === 1 ? 'goodsId' : 'prodList'
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: form.value.configType,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.configType = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: 0
                }, {
                  default: _withCtx(() => [_hoisted_3]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: 1
                }, {
                  default: _withCtx(() => [_hoisted_4]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: 2
                }, {
                  default: _withCtx(() => [_hoisted_5]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"]), _hoisted_6, _withDirectives(_createVNode(_component_el_row, {
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [form.value.goodsId ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(form.value.prodName || ''), 1)) : _createCommentVNode("", true), !__props.isSee ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "primary",
                  onClick: _cache[8] || (_cache[8] = $event => showAddProductModal.value = true),
                  onSuccess: addProdSuccess
                }, {
                  default: _withCtx(() => [_hoisted_8]),
                  _: 1
                })) : _createCommentVNode("", true)]),
                _: 1
              }, 512), [[_vShow, form.value.configType === 1]]), _withDirectives(_createElementVNode("div", _hoisted_9, [form.value.prodList.length ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(form.value.prodNames || ''), 1)) : _createCommentVNode("", true), !__props.isSee ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                onClick: _cache[9] || (_cache[9] = $event => showAddProductModal.value = true),
                onSuccess: addProdSuccess
              }, {
                default: _withCtx(() => [_hoisted_11]),
                _: 1
              })) : _createCommentVNode("", true)], 512), [[_vShow, form.value.configType === 2]])]),
              _: 1
            }, 8, ["prop"]), form.value.configType === 2 ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "介绍图片",
              rules: {
                required: true,
                message: '请上传介绍图片'
              },
              prop: "picList"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_upload, {
                action: option.action,
                multiple: false,
                name: option.name,
                "before-upload": beforeUpload,
                "on-preview": previewImg,
                "on-success": e => uploadSuccess(e, 'picList'),
                "list-type": "picture-card",
                disabled: __props.isSee,
                "file-list": form.value.picList,
                "onUpdate:file-list": _cache[10] || (_cache[10] = $event => form.value.picList = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_Plus)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["action", "name", "on-success", "disabled", "file-list"]), _createVNode(_component_el_alert, {
                type: "warning",
                title: "上传图文介绍图片。建议尺寸 宽度375px 高度不限, 大小不可超过400kb, 格式为png、jpg、jpeg"
              })]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["model"])]),
          _: 1
        }, 512), (_openBlock(), _createBlock(AddAttractProductModal, {
          checkMode: form.value.configType === 1 ? 'radio' : 'checkbox',
          key: form.value.configType,
          modelValue: showAddProductModal.value,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => showAddProductModal.value = $event),
          onSuccess: addProdSuccess
        }, null, 8, ["checkMode", "modelValue"])), _createVNode(_component_el_dialog, {
          modelValue: showImgModal.value,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => showImgModal.value = $event),
          width: "600px"
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: showImgUrl.value,
            style: {
              "width": "100%"
            },
            alt: "Preview Image"
          }, null, 8, _hoisted_12)]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }

};